import { WSForm, WSInputText } from "@wingspanhq/fe-component-library";
import { AttributeDefinition } from "@wingspanhq/wingspan-api-sdk";

type Props = {
  definition: AttributeDefinition;
  disabled?: boolean;
};

export const FieldString: React.FC<Props> = props => {
  return (
    <WSForm.Field
      name={props.definition.key}
      component={WSInputText}
      componentProps={{
        label: props.definition.name,
        helperText: props.definition.description,
        required: props.definition.isRequired,
        disabled: props.disabled
      }}
    />
  );
};
